module.exports = __webpack_public_path__ + "img/percent.f9aef2e9.png";